import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { motion } from "framer-motion";
import { useCart } from "../context/CartContext";
import { formatPrice, imgUrl } from "../lib/api";

export const ProductBadges = ({ p }) => (
  <div className="absolute top-3 left-3 flex flex-col gap-1.5 z-10">
    {p.is_example && <span className="bg-[#0B0B0B]/80 backdrop-blur text-[#C9A45C] border border-[#C9A45C]/40 text-[10px] tracking-[0.2em] uppercase px-2 py-1" data-testid="badge-example">Exemple</span>}
    {p.is_new && <span className="bg-[#C9A45C] text-[#0B0B0B] text-[10px] tracking-[0.2em] uppercase px-2 py-1">Nouveau</span>}
    {p.stock <= 0 && <span className="bg-[#242424] text-[#F8F6F1]/80 text-[10px] tracking-[0.2em] uppercase px-2 py-1">Épuisé</span>}
  </div>
);

export const ProductCard = ({ p, index = 0 }) => {
  const { add } = useCart();
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08 }}
      className="group relative"
      data-testid={`product-card-${p.slug}`}
    >
      <Link to={`/parfum/${p.slug}`} className="block relative overflow-hidden bg-[#141414] aspect-[4/5]" data-testid={`product-card-link-${p.slug}`}>
        <ProductBadges p={p} />
        <img src={imgUrl(p.images?.[0])} alt={p.name} loading="lazy"
          className={`h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105 ${p.stock <= 0 ? "opacity-50 grayscale" : ""}`} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B]/70 via-transparent to-transparent opacity-80" />
      </Link>
      {p.stock > 0 && (
        <button
          onClick={() => add(p, 1)}
          aria-label={`Ajouter ${p.name} au panier`}
          data-testid={`product-card-add-to-cart-${p.slug}`}
          className="absolute right-3 top-3 z-10 h-10 w-10 flex items-center justify-center bg-[#0B0B0B]/70 backdrop-blur border border-[#C9A45C]/40 text-[#C9A45C] hover:bg-[#C9A45C] hover:text-[#0B0B0B] transition-colors duration-300 sm:opacity-0 sm:group-hover:opacity-100"
        >
          <Plus className="h-4 w-4" />
        </button>
      )}
      <div className="pt-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[10px] tracking-[0.25em] uppercase text-[#F8F6F1]/45 truncate">{[p.brand, p.volume_ml ? `${p.volume_ml} ml` : ""].filter(Boolean).join(" · ") || "NasDeal"}</p>
          <Link to={`/parfum/${p.slug}`} className="font-display text-xl text-[#F8F6F1] hover:text-[#E5C178] transition-colors duration-300 leading-snug block truncate">
            {p.name}
          </Link>
        </div>
        <p className="text-[#C9A45C] text-sm whitespace-nowrap pt-4" data-testid={`product-card-price-${p.slug}`}>{formatPrice(p.price)}</p>
      </div>
    </motion.article>
  );
};

export const ProductGrid = ({ products, testid = "product-grid" }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10 sm:gap-x-6" data-testid={testid}>
    {products.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
  </div>
);
